import React from "react";
import AppBody from "../components/AppBody";
import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { getSkills } from "../../actions/trainer/trainer_skills_action";
import CreateCategoryModel from "../admin/certification/CreateCategoryModel";
import { categoryList } from "../../actions/admin/certification/category_action";
import { useEffect } from "react";
import CreateSkillModel from "./CreateSkillModel";

import { useForm } from "react-hook-form";
import {
  createTrainerCertificate,
  getTrainerCertificate,
  updateTrainerCertificate,
} from "../../actions/trainer/trainer_certificate_action";
const UpdateTrainerCertificate = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useSelector((state) => state.trainerCertificateReducer);
  const { id } = useParams();
  const categoryState = useSelector((state) => state.categoryReducer);
  const skillState = useSelector((state) => state.trainerSkillReducer);
  const [categoyModel, setCategoyModel] = useState(false);
  const [skillModel, setSkillModel] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [isDeta, isSetData] = useState(false);
  const [trainerCertificate, setTrainerCertificate] = useState({
    skill_id: "",
    certificate_name: "",
    certificate_image: "",
    verify_link: "",
    certify_date: "",
    category_id: "",
    id: id,
  });

  useEffect(() => {
    dispatch(categoryList());
    dispatch(getTrainerCertificate({ id: id }));
  }, []);

  if (state.is_done) {
    toast("Record added successfully!", {
      type: "success",
      position: "top-center",
    });
    navigate("/trainer/certificate/list");
  }

  if (!isDeta && state.trainerSkillCertificate.certificate_name) {
    setTrainerCertificate({ ...state.trainerSkillCertificate });
    isSetData(true);
  }

  const handelClosePopup = () => {
    setCategoyModel(false);
    setSkillModel(false);
    dispatch(getSkills({ category_id: trainerCertificate.category_id }));
    dispatch(categoryList());
  };
  const onSubmit = (data) => {
    const formData = new FormData();
    if (data.certificate_image) {
      formData.append("certificate_image", data.certificate_image[0]);
    }
    formData.append("certificate_name", trainerCertificate.certificate_name);
    formData.append("id", trainerCertificate.id);
    formData.append("verify_link", trainerCertificate.verify_link);
    formData.append("skill_id", trainerCertificate.skill_id);
    formData.append("certify_date", trainerCertificate.certify_date);
    dispatch(updateTrainerCertificate(formData));
  };

  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="">
            <div className="card">
              <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
                <Link
                  to={"/trainer/certificate/list"}
                  className="d-inline-block mt-2"
                >
                  <i className="ti-arrow-left font-sm text-white"></i>
                </Link>
                <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                  Update Skill Certificate
                </h4>
              </div>
              <div className="card-body  p-4 w-100 border-0 ">
                <ToastContainer />
                <form
                  onSubmit={handleSubmit(onSubmit)}
                  enctype="multipart/form-data"
                >
                  {categoyModel && (
                    <CreateCategoryModel
                      show={categoyModel}
                      isAction={1}
                      handelUpdateShow={() => handelClosePopup()}
                    />
                  )}

                  {skillModel && (
                    <CreateSkillModel
                      show={skillModel}
                      category={trainerCertificate.category_id}
                      handelUpdateShow={() => handelClosePopup()}
                    />
                  )}

                  <div className="row">
                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Select Category
                        </label>
                        <select
                          className="form-control"
                          name={"category_id"}
                          onChange={(e) => {
                            setTrainerCertificate({
                              ...trainerCertificate,
                              category_id: e.target.value,
                            });
                            dispatch(
                              getSkills({ category_id: e.target.value })
                            );
                          }}
                        >
                          <option>Select Category</option>
                          {categoryState.list &&
                            categoryState.list.map((li, i) => (
                              <option value={li.id}>{li.name}</option>
                            ))}
                        </select>
                        <span className="error-msg">
                          {state.errors.category_id
                            ? state.errors.category_id
                            : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-2">
                      <input
                        type="button"
                        name="submit"
                        value="Add Category"
                        onClick={() => setCategoyModel(true)}
                        className="btn-common px-3 mt-30"
                      />
                    </div>
                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Select Skill
                        </label>
                        <select
                          className="form-control"
                          name={"skill_id"}
                          onChange={(e) =>
                            setTrainerCertificate({
                              ...trainerCertificate,
                              skill_id: e.target.value,
                            })
                          }
                        >
                          <option>Select Skill</option>
                          {skillState.skills &&
                            skillState.skills.map((li, i) => (
                              <option value={li.id}>{li.name}</option>
                            ))}
                        </select>
                        <span className="error-msg">
                          {state.errors.skill_id ? state.errors.skill_id : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-2 ">
                      <input
                        type="button"
                        name="submit"
                        value="Add Skill"
                        disabled={
                          !trainerCertificate.category_id ? true : false
                        }
                        onClick={() => setSkillModel(true)}
                        className="btn-common px-3 mt-30"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Certificate Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={trainerCertificate.certificate_name}
                          onChange={(e) =>
                            setTrainerCertificate({
                              ...trainerCertificate,
                              certificate_name: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.certificate_name
                            ? state.errors.certificate_name
                            : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-6 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Certify Date
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          value={trainerCertificate.certify_date}
                          onChange={(e) =>
                            setTrainerCertificate({
                              ...trainerCertificate,
                              certify_date: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.certify_date
                            ? state.errors.certify_date
                            : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Verify Link
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={trainerCertificate.verify_link}
                          onChange={(e) =>
                            setTrainerCertificate({
                              ...trainerCertificate,
                              verify_link: e.target.value,
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors.verify_link
                            ? state.errors.verify_link
                            : ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-lg-6 mb-2">
                      <label className="mont-font fw-600 font-xsss">
                        Upload Certificate Image
                      </label>
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          accept=".png, .jpg, .jpeg"
                          {...register("certificate_image")}
                        />
                        <label class="custom-file-label" htmlFor="customFile">
                          Chosose Certificate Image
                        </label>

                        <span className="error-msg">
                          {state.errors.certificate_image
                            ? state.errors.certificate_image
                            : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-12">
                      <input
                        type="submit"
                        name="submit"
                        value="Submit"
                        className="btn-common px-5"
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default UpdateTrainerCertificate;
